export default __webpack_public_path__ + "static/logo-ff1c022cac0ffadd5942e262e80b441a.svg";